module.exports = __webpack_public_path__ + "media/application/images/2022/online-4fd270af1203e15f95b55146a5210ee8.jpg";